<template>
  <div>
    <div class="container-fluid">
      <nav-bar-component></nav-bar-component>
      <setup-menu-nav-component></setup-menu-nav-component>
    </div>
    <div class="container-fluid">
      
      <div class="row justify-content-center">
        
        <div class="col-md-10">
          <div class="container">
            <form>
              <div class="form-group">
                <label for="eventTypeNameInput">Event Type Name</label>                
                <input v-model="eventTypeName" placeholder="" class="form-control" id="eventTypeNameInput" @change="isSavable = true;">
              </div>
              <div class="form-group">
                <label for="eventTypeDescriptionInput">Description</label>                
                <input v-model="eventTypeDescription" placeholder="" class="form-control" id="eventTypeDescriptionInput" @change="isSavable = true;">
              </div>

              <div class="form-group" v-show="isEditMode">
                <label for="apiNameInput">API Endpoint</label>
                <div class="input-group mb-3">
                  <input v-model="eventTypeAPIName" class="form-control" id="apiNameInput" readonly>
                  <div class="input-group-append">
                    
                    <div class="tooltip bs-tooltip-top" role="tooltip" :class="(isCopied ? 'show' : 'hide')" >
                      <div class="arrow"></div>
                      <div class="tooltip-inner">
                        Copied to clipboard!
                      </div>
                    </div>
                    <button class="btn btn-outline-secondary" type="button" data-toggle="tooltip" @click="copyToClipboard" id="copyButton" >Copy</button>
                  </div>
                </div>
                
              </div>                          

              <h5>Templates</h5>
              <b-card>
              <div class="form-group" >
                <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Message Body</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="cur in existingTemplateList" v-bind:key="cur.id">
                    <td><b-link :to="{path:'/templates/' + cur.id}" class="btn-link template-link">{{cur.get("Name")}}</b-link></td>
                    <td>{{cur.get("MessageBody")}}</td>
                    <td><b-link :to="{path:'/templates/' + cur.id}" title="edit"><b-icon icon="pencil" variant="primary"></b-icon></b-link></td>
                    <td><a href="#" v-on:click="deleteTemplateRelation(cur)" title="delete"><b-icon icon="trash" variant="danger"></b-icon></a></td>
                  </tr> <!--<img src="./../assets/open-iconic-master/svg/trash.svg"> -->
                </tbody>
                </table>
                <div class="form-group" v-if="showAddTemplate">
                  <label for="templateInput">Template</label>
                  <select v-model="selectedTemplate" class="form-control" id="templateInput">
                      <option disabled value="">Select a template</option>
                      <option v-for="curTemplate in templateList" v-bind:key="curTemplate.id" :value="curTemplate.id">{{curTemplate.get("Name")}}</option>
                  </select>
                </div>
                <b-button variant="link" @click="addTemplate">
                  + Add Template
                </b-button>
              </div>
                
              </b-card>
              <div class="button-area">
                <div class="buttons-left">
                  <div class="btn-group" role="group">
                  <b-button type="button" variant="outline-secondary" @click="cancel">Cancel</b-button>
                  </div>
                  <div class="btn-group" role="group">
                  <button type="button" class="btn btn-primary btn-save" :disabled="!isSavable" :class="(isSavable ? '' : 'disabled')" v-on:click="insertEventType">Save changes</button>
                  </div>
                </div>
                <div class="buttons-right">
                  <div class="btn-group" role="group">
                  <button type="button" class="btn btn-outline-danger" v-on:click="deleteEventType" v-show="isEditMode">Delete</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>     
  </div>
</template>

<script>
// @ is an alias to /src
// Your corresponding keys
import NavBarComponent from '@/components/NavBarComponent.vue'
import SetupMenuNavComponent from '@/components/SetupMenuNavComponent.vue'

var Parse = require('parse/node');
Parse.initialize(process.env.VUE_APP_PARSE_APP_ID, process.env.VUE_APP_PARSE_JS_KEY, process.env.VUE_APP_PARSE_MASTER_KEY);
Parse.serverURL = process.env.VUE_APP_PARSE_SERVER_URL;

export default {
  name: 'EventTypeEditorComponent',
  components: {
    NavBarComponent,
    SetupMenuNavComponent
  },
  created() {
    
  },
  mounted: function () {

    this.fetchUserFields();        
    if (this.$route.params.id && this.$route.params.id != 'new') {
      this.eventTypeId = this.$route.params.id;
      this.isEditMode = true;
      this.fetchEventType();
    } else {
      this.isSavable = true;
    }
    this.fetchTemplates();
  },
  data: function () {
    return {
      companyId: "",
      eventTypeName: "",
      eventTypeAPIName: "",
      eventTypeDescription: "",
      eventTypeId : "",
      existingTemplateList : [],
      selectedTemplate : "",
      templateList : "",
      showAddTemplate : false,
      isCopied : false,
      isSavable : false,
      isEditMode : false
    }
  },
  methods: {
    fetchUserFields() {
      const query1 = new Parse.Query(Parse.User);
      query1.get(Parse.User.current().id).then((user) => {
        
        this.companyId = user.attributes.CompanyId.id;
      }, (error) => {
        console.error('Error while fetching user', error);
      });
    },
    fetchEventType() {
      const EventType = Parse.Object.extend("EventType");
      const query = new Parse.Query(EventType);
        query.equalTo("objectId", this.eventTypeId );
        query.include("NotificationTemplates");
        query.first().then((resultObject) => {
          this.eventTypeName = resultObject.get("Name");
          this.eventTypeDescription = resultObject.get("Description");
          this.eventTypeAPIName = 'https://api.ravenhub.io/company/' + this.companyId + '/subscribers/<subscriber_id>/events/' +  resultObject.id;
          
          resultObject.relation("NotificationTemplates").query().each((relatedObject) => {    
            console.log("related obj: " + relatedObject.id);
            this.existingTemplateList.push(relatedObject);
            this.$emit('data-loaded');
          });
          this.isSavable = false;
          
        })
        
        
    },
    insertEventType() {
      if (!this.eventTypeName || this.eventTypeName === 0) return;

      var todo_acl = new Parse.ACL();
      todo_acl.setWriteAccess( Parse.User.current(), true);
      todo_acl.setPublicReadAccess( true);
      console.log("company id : " + this.companyId);
      const Company = Parse.Object.extend('Company');
      var companyPointer = Company.createWithoutData(this.companyId);

      var eventTypeToInsert = {};  
      if (this.eventTypeId && this.eventTypeId.length > 0) {
        eventTypeToInsert = new Parse.Object("EventType", {
          "objectId" : this.eventTypeId,
          "Name": this.eventTypeName,
          "Description": this.eventTypeDescription,
          "CompanyId": companyPointer,
          "Type": "Event"
        });
      } else {
        eventTypeToInsert = new Parse.Object("EventType", {
          //"objectId" : this.eventTypeId,
          "Name": this.eventTypeName,
          "Description": this.eventTypeDescription,
          "CompanyId": companyPointer,
          "Type": "Event"
        });
      }
      
      if (this.selectedTemplate != '') {
        console.log('saving template relation: ' + this.selectedTemplate);
        var templateRelation = eventTypeToInsert.relation("NotificationTemplates");
        var TemplateObject = Parse.Object.extend('NotificationTemplate');
        var templatePointer = TemplateObject.createWithoutData(this.selectedTemplate);
        templateRelation.add(templatePointer);
      }

      eventTypeToInsert.setACL(todo_acl);
      eventTypeToInsert.save()
        .then((result) => {
          
          console.log(result);
          console.log('result id = ' + result.id);
          this.isSavable = false;
          this.$router.replace("/event-types");
        })
        .catch((function (e) {
          console.log("Error saving event type! " + e.message);
        }))
    },
    cancel() {
      this.$router.replace("/event-types");
    },
    fetchTemplates() {
      const query1 = new Parse.Query(Parse.User);
      query1.get(Parse.User.current().id).then((user) => {
        console.log('User found', user.attributes.CompanyId.id);
        this.companyId = user.attributes.CompanyId.id;

        const Template = Parse.Object.extend("NotificationTemplate");
        const query = new Parse.Query(Template);
        query.equalTo("CompanyId", { "__type": "Pointer", "className": "Company", "objectId": this.companyId });
        query.descending("Name");
        query.find().then((templateList) => {
          this.templateList = templateList;
          this.loading = false;
        })

      }, (error) => {
        console.error('Error while fetching user', error);
        this.error = error;
      });

      
    },
    addTemplate() {
      this.showAddTemplate = true;
      this.isSavable = true;
    },
    deleteTemplateRelation(templateToDelete) {
      const EventType = Parse.Object.extend('EventType');
      var eventTypePointer = EventType.createWithoutData(this.eventTypeId);

      var templateRelation = eventTypePointer.relation("NotificationTemplates");
      var TemplateObject = Parse.Object.extend('NotificationTemplate');
      var templatePointer = TemplateObject.createWithoutData(templateToDelete.id);
      templateRelation.remove(templatePointer);
      eventTypePointer.save().then((result) => {
        console.log("templatetodelete = " + templateToDelete);
        const index = this.existingTemplateList.indexOf(templateToDelete);
        console.log("result = " + result);
        console.log("index = " + index);        
        if (index > -1) {
          this.existingTemplateList.splice(index, 1);
        }
      }, (error) => {
        console.error('Error while deleting template relation', error);
      });
    },
    deleteEventType() {
      const EventType = Parse.Object.extend('EventType');
      const query = new Parse.Query(EventType);
      
      query.get(this.eventTypeId).then((object) => {
        object.destroy().then((response) => {
          console.log('Deleted EventType', response);
          this.$router.replace("/event-types");
        }, (error) => {
          console.error('Error while deleting EventType', error);
        });
      });
    },
    copyToClipboard() {
      var copyText = document.querySelector("#apiNameInput");
      copyText.select();
      document.execCommand("copy");
      this.isCopied = true;
      setTimeout(() => {
        this.isCopied = false;
      }, 3000);
    }
    
  }
}
</script>

<style>
.button-area {
  margin-top:10px;
}
.bs-tooltip-top.show {
  animation: scaleIn .15s ease-in-out 0s 1 normal forwards;
  margin-top: -60px;
}
.bs-tooltip-top.hide {
  display: none;
}
.buttons-left {
  display:inline-flex;
}
.btn-group {
  margin-right: 20px;
}
.buttons-right {
  display:inline-flex;
  float:right;
}
.template-link {
  font-weight: 500;
}


</style>
